import { render, staticRenderFns } from "./CommentCardDisplay.vue?vue&type=template&id=d39e470e&scoped=true&"
import script from "./CommentCardDisplay.vue?vue&type=script&lang=js&"
export * from "./CommentCardDisplay.vue?vue&type=script&lang=js&"
import style0 from "./CommentCardDisplay.vue?vue&type=style&index=0&id=d39e470e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d39e470e",
  null
  
)

export default component.exports